import object from '@mailobj-browser/front/js/utils/object.js'

export const block = 'ea_generics__completion'

export const elements = object(null, {
  current: `${block}_current`,
  list: `${block}_list`,
  item: `${block}_item`,
  itemText: `${block}_item_text`,
  itemContent: `${block}_item_content`
})

export const modifiers = object(null, {
  list: object(null, {
    open: `${elements.list}-open`
  })
})
